export default __webpack_public_path__ + "static/gem-visa-rich-banner-61b73b7a0512229826ae2e5702f1d80f.png";